import { useState } from "react";

import { amendMention } from "@/api/endpoints/episodes";
import Button from "@/components/Button";
import { Textarea } from "@components/Field";
import Modal, {
  ModalContent,
  ModalDescription,
  ModalFooter,
  ModalHeader,
} from "@components/Modal";

// `text` is v4, `content` is v1.
const getMentionText = (mention) =>
  mention.text ? mention.text : mention.content;

const EditMentionModal = ({ show, onHide, mention, updateMention }) => {
  // states
  const [editedMentionText, setEditedMentionText] = useState(
    getMentionText(mention)
  );

  // Side-effects
  const [prevMention, setPrevMention] = useState(mention);
  if (mention !== prevMention) {
    setPrevMention(mention);
    setEditedMentionText(getMentionText(mention));
  }

  const submit = (e) => {
    onHide();
    e.preventDefault();
    amendMention(mention.public_id, { mention_text: editedMentionText })
      .then((response) => {
        updateMention(response.data);
      })
      .catch(() => {
        // do nothing?
      });
  };

  return (
    <Modal show={show} onHide={onHide}>
      <ModalHeader>
        <ModalDescription>
          {`${L.MENTIONS_EDIT_EDITING} ${mention.episode_title}`}
        </ModalDescription>
      </ModalHeader>
      <ModalContent>
        <Textarea
          value={editedMentionText}
          onChange={(e) => setEditedMentionText(e.target.value)}
          data-testid="mention-content-edit"
        />
      </ModalContent>
      <ModalFooter>
        <Button variant="secondary" onClick={onHide}>
          {L.MENTIONS_EDIT_BAR_CANCEL}
        </Button>
        <Button onClick={submit} data-testid="save-edit-button">
          {L.MENTIONS_EDIT_BAR_SAVE}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default EditMentionModal;
